/* eslint-disable jsx-a11y/anchor-is-valid */
import { Input, Space, Table, Tag } from 'antd';
import { Investor } from 'procura-shared';
import React, { useState } from 'react';
import Highlighter from 'react-highlight-words';
import { useTranslation } from 'react-i18next';
import '../styles/investors-table.less';
import { investorErrors } from '../utilities/Utilities';
import { NewInvestorButton } from './Components';

type InvestorsTableProps = {
  investors?: Investor[];
  search?: boolean;
  loading?: boolean;
  errors?: boolean;
  adminMode?: boolean;
  onSelect?: (investor: Investor) => void;
};

export const InvestorsTable = ({
  investors = [],
  search = false,
  loading = false,
  errors = false,
  adminMode = false,
  onSelect,
}: InvestorsTableProps) => {
  const { t } = useTranslation();

  const [searchInput, setSearchInput] = useState('');

  const isBigTable = (): Boolean => (noData() ? false : investors.length > 12);
  const noData = (): Boolean => investors == null || investors.length === 0;

  const searchInputHandler = (e) => {
    setSearchInput(e.target.value);
  };

  const investorClickHandler = (investor: Investor) => {
    onSelect?.(investor);
  };

  const filter = (input: string, investor: Investor): Boolean =>
    investor.name?.toLocaleLowerCase().includes(input.toLowerCase()) ||
    investor.contactEmail?.toLocaleLowerCase().includes(input.toLowerCase()) ||
    investor.privateEmail?.toLocaleLowerCase().includes(input.toLowerCase());

  const tableData = () =>
    (searchInput === '' ? investors : investors.filter((investor) => filter(searchInput, investor)))
      .sort()
      .map((e, i) => ({ ...e, key: i }));

  const tableColumns = () => [
    {
      title: t('name'),
      dataIndex: 'name',
      key: 'name',
      render: (_text, investor) => (
        <Space>
          <a onClick={() => investorClickHandler(investor)}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[searchInput]}
              autoEscape
              textToHighlight={investor.name ?? investor.contactEmail ?? ''}
            />
          </a>
        </Space>
      ),
    },
    {
      title: t('email'),
      dataIndex: 'contactEmail',
      key: 'contactEmail',
      render: (text, investor) => (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchInput]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ),
    },
    ...(errors
      ? [
          {
            title: t('errors'),
            key: 'errors',
            render: (text, investor) => investorErrors(investor, t).map((error) => <Tag color="warning">{error}</Tag>),
          },
        ]
      : []),
  ];
  return (
    <div className="pg-investors-table">
      <>
        <Space direction="vertical" style={{ width: '100%' }}>
          {search && (
            <Input.Search
              allowClear
              placeholder={t('search')}
              onChange={(e) => searchInputHandler(e)}
              onInput={(e) => searchInputHandler(e)}
              style={{ marginBottom: 16 }}
            />
          )}
          {adminMode && <NewInvestorButton />}
        </Space>
        <Table
          pagination={false}
          loading={loading}
          bordered
          dataSource={tableData()}
          columns={tableColumns()}
          scroll={{ y: 500 }}
          sticky
          size={isBigTable() ? 'small' : 'large'}
        />
      </>
    </div>
  );
};
